import React, { useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import "./styles/SearchField.css";

/**
 * SearchField - Reusable search input with icon
 * @param {Object} props
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.value - Current value
 * @param {Function} props.onChange - Change handler, receives a change event
 * @param {string} props.ariaLabel - Accessible name, defaults to the placeholder
 */
const SearchField = ({ placeholder, value, onChange, ariaLabel }) => {
  const [focused, setFocused] = useState(false);

  // Callers all read e.target.value, so clearing sends the same shape.
  const handleClear = () => onChange({ target: { value: "" } });

  return (
    <div className={`searchField ${focused ? "isFocused" : ""}`}>
      <SearchIcon className="searchFieldIcon" />
      <input
        type="text"
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder || "Search"}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {value && (
        <button
          type="button"
          className="searchFieldClear"
          onClick={handleClear}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default SearchField;
